"use strict";

export default sb => {
    let moreInfoTrigger;
    let dialogWidth;

    const toggleMoreInfo = function toggleMoreInfo(e) {
        e.preventDefault();
        dialogWidth = jQuery(window).width() < 800 ? '100%' : '35%';
        jQuery( function() {
            jQuery( "#dialog" ).dialog({
                modal: true,
                open: function() {
                    jQuery('.ui-widget-overlay').addClass('custom-overlay');
                },
                width: dialogWidth,
                maxWidth: "768px"
            });
        });
        jQuery(".ui-dialog-title").hide();
    };

    return {
        init() {
            moreInfoTrigger = jQuery("#more_info_trigger");
            sb.addEvent(moreInfoTrigger, "click", toggleMoreInfo);
        },
        destroy() {
            sb.removeEvent(moreInfoTrigger, "click", toggleMoreInfo);
            moreInfoTrigger = null;
        }
    }
}
